// extracted by mini-css-extract-plugin
export default {"section":"styles_section__rYsK-","isFancy":"styles_isFancy__FTQmZ"};